<template>
    <div class="biz-user-menu" @mouseenter="dropDown(), arrowImg.now = arrowImg.hover" @mouseleave="dropUp(), arrowImg.now = arrowImg.default">
        <span class="user-title">
            <div class="shot">
                <img v-if="userShot" :src="userShot" alt="">
                <img v-else src="@/assets/img/shot.svg" alt="">    
            </div>
            <div v-if="isAllGroup  || isBizVerified != 'NORMAL'" class="name-group">
                <div class="name">
                    {{userName}} 
                </div>
            </div>
            <div v-else class="name-group">
                <div class="name">
                    {{userName}} /  
                </div>
                <div class="group">
                    {{userGroupName}}
                </div>
            </div>
            <img class="arrow" :src="arrowImg.now" alt="">
        </span>
        <transition  name="fade"> 
            <ul v-show="show" @click="dropUp">
                <router-link  :to="{ name: 'bizPersonalCenterDefault'}">
                    <li>個人中心</li>
                </router-link>
                <!-- <router-link  :to="{ path: ''}">
                    <li>操作指南</li>
                </router-link> -->
                <a href="/bizPrivacyPolicy" target="_blank" rel="noopener noreferrer">
                    <li>隱私權政策</li>
                </a>
                <a href="/bizUserTerms" target="_blank" rel="noopener noreferrer">
                    <li>會員條款</li>
                </a>
                <!-- <a @click="$analytics.logEvent('操作指南', { screen_name: '操作指南'})" href="https://flypig-public.s3-ap-southeast-1.amazonaws.com/doc/manual.pdf" target="_blank" rel="noopener noreferrer">
                    <li>操作指南</li>
                </a> -->
                <!-- <router-link  :to="{ path: ''}">
                    <li>版本</li>
                </router-link> -->
                <li class="logout" @click="logout(), $analyticsBiz.logEvent('使用者選單_登出', { screen_name: '使用者選單_登出'})">登出</li>
            </ul>
        </transition> 
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'UserMenu',
    data () {
        return {
            show: 0,
            arrowImg: {
                now: require('@/assets/img/icon/arrow_down_gray.svg'),
                default: require('@/assets/img/icon/arrow_down_gray.svg'),
                hover: require('@/assets/img/icon/arrow_up_black.svg')
            }
        }
    },
    mounted () {
        this.$store.dispatch('getBizPersonalInfo')
    },
    methods: {
        dropDown: function () {
            this.show = 1;
            document.getElementsByClassName('biz-tool-bar')[0].style.zIndex = 9
        },
        dropUp: function () {
            this.show = 0;
            document.getElementsByClassName('biz-tool-bar')[0].style.zIndex = 7
        },
        logout: function () {
            this.$store.dispatch('bizLogout')
        }
    },
    computed: {
        ...mapGetters({
            userShot: 'BIZ_GET_PERSONAL_SHOT',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            userGroupName: 'GET_BIZ_GROUP_NAME',
            userName: 'GET_BIZ_USER_NAME',
            isBizVerified: 'GET_BIZ_COMPANY_IS_VERIFIED',

        })
    }
}
</script>
<style scoped lang="scss">
    .biz-user-menu{
        // width: 44px;
        // height: 44px;
        position: relative;
        margin-left: 18px;
        cursor: pointer;
        .user-title{
            display: flex;
            align-items: center;
            .shot{
                width: 44px;
                height: 44px; 
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                margin-right: 8px;
                box-shadow: 0px 2px 4px rgba(165, 166, 187, 0.2);
                overflow: hidden;
                img{
                    width: 44px;
                }
            }
            .name-group{
                display: flex;
                align-items: center;
                .name{
                    color: #a19d9c
                }
            }
        }
        ul{
            position: absolute;
            // right: -31px;
            width: 187px;
            padding: 4px 0;
            border-radius: 4px;
            // background: #000;
            background: #f0f0f0;
            top: 47px;
            border: solid 1px #eeeeee;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            z-index: 9999;
            li{
                position: relative;
                display: flex;
                align-items: center;
                padding: 12px 24px;
                cursor: pointer;
                a{
                    display: flex;
                    align-items: center;
                }
            }
            li:hover{
                background: #fff;
            }
            li.logout{
                color: #ff9275;
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .biz-user-menu{
            ul{
                left: -50px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/menu/bizUserMenu.vue